import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FALLBACK_CONFIG } from "@/data/siteContent";

const SiteContext = createContext(FALLBACK_CONFIG);

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK_CONFIG);
  useEffect(() => {
    api.get("/site-config")
      .then((res) => setConfig({ ...FALLBACK_CONFIG, ...res.data }))
      .catch(() => {});
  }, []);
  return <SiteContext.Provider value={config}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}
